import contractSuccessAlertDictionary from '@widgets/contract-success-alert/i18n/ru/contract-success-alert.dic.json';

export const contractSuccessAlert = {
  CONTRACT_SUCCESS_ALERT: contractSuccessAlertDictionary,
};

export const contractSuccessAlertNamespaces = ['CONTRACT_SUCCESS_ALERT'];
